import { useState } from "react";
import { Radar, ExternalLink } from "lucide-react";

export const CargoTracker = () => {
  const [number, setNumber] = useState("");
  const ok = number.trim().length > 0;
  return (
    <form action="https://connect.track-trace.com/for/heliopolis" method="post" target="_blank" rel="noopener" className="space-y-3" data-testid="cargo-tracker-form" onSubmit={(e) => { if (!ok) e.preventDefault(); }}>
      <input type="hidden" name="shipper" value="aircargo" />
      <p className="text-sm text-[#64748B]">Enter an air waybill / tracking number to open live air cargo tracking in a new tab.</p>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Radar size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#377DD3]" />
          <input type="text" name="number" value={number} onChange={(e) => setNumber(e.target.value)} placeholder="e.g. 176-12345675" autoComplete="off" className="h-11 w-full rounded-xl border border-[#377DD3]/20 bg-[#F7FAFC] dark:bg-muted/40 pl-9 pr-3 text-sm font-medium tracking-wide text-[#0D1B2A] dark:text-foreground outline-none focus:border-[#377DD3] focus:ring-2 focus:ring-[#377DD3]/20 transition" data-testid="cargo-tracker-input" />
        </div>
        <button type="submit" disabled={!ok} className="h-11 inline-flex items-center gap-1.5 rounded-xl bg-[#0D1B2A] px-4 text-sm font-semibold text-white hover:bg-[#1C3252] disabled:opacity-40 transition-colors" data-testid="cargo-tracker-submit">Track <ExternalLink size={14} /></button>
      </div>
    </form>
  );
};
